import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import errorCb from 'Common/Utils/errorCb';
import AsyncSelect from 'Common/Components/AsyncSelect/AsyncSelect';
import { fetchTypes } from '../../AmendContract.service';
import classes from './TypeSelector.module.css';

const emptyType = { type: null, description: null };

function TypeSelector({
    year,
    grouping,
    value,
    onChange,
    onLoad
}) {
    const [description, setDescription] = useState();
    const [types, setTypes] = useState([]);
    const globalDispatch = useDispatch();
    const typesPromise = useMemo(() =>
        fetchTypes(year, grouping, errorCb([], 'Error fetching Types.', globalDispatch)),
        [year, grouping, globalDispatch]);

    useEffect(() => {
        setDescription('');
    }, [year, grouping]);

    const handleChange = useCallback(e => {
        const val = e.target.value;
        setDescription(findDescription(val, types));
        onChange(val);
    }, [types, onChange]);

    const handleLoad = useCallback(data => {
        setTypes(data || []);
        if (value) {
            setDescription(findDescription(value, data));
        }
        onLoad && onLoad(data);
    }, [value, onLoad]);

    return (
        <div className={classes['type-selector__container']}>
            <Typography id="type-selector-label" variant="subtitle1" component="label" htmlFor="type-selector">Type:</Typography>
            <div className={classes['type-selector__content']}>
                <AsyncSelect
                    id="type-selector"
                    className={classes['type-selector__input']}
                    dataSource={typesPromise}
                    labelId="type-selector-label"
                    value={value}
                    valueField="type"
                    onChange={handleChange}
                    onLoad={handleLoad}
                />
                {description && (
                    <span className={classes['type-selector__description']}>{description}</span>
                )}
            </div>
        </div>
    );
}

function findDescription(val, types) {
    if (!types || !types.length || !val) {
        return null;
    }

    return (types.find(t => t.type === val) ?? emptyType).description;
}

TypeSelector.propTypes = {
    year: PropTypes.string.isRequired,
    grouping: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired
};

export default TypeSelector;
